import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError, GetListResponse } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { EarningsListItem } from "../../financial.types";
import { requestEarnings } from "./earnings.request";
import { EarningsParams } from "./earnings.types";

const useEarnings = (
  requestParams: EarningsParams,
  options?: QueryOptions<
    GetListResponse<EarningsListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["earnings", requestParams],
    queryFn: async () => await requestEarnings(requestParams),
    ...options
  });

  return { earnings: data?.data, meta: data?.meta, ...rest };
};

export default useEarnings;
